import Input from 'client/components/Form/Input';
import Validators from 'client/helpers/formValidator';
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { useResetPassword } from './useResetPassword';

const ResetPassword = () => {
  const { onSubmit, formMethods, isLoading, t } = useResetPassword();

  return (
    <div className=" container  mx-auto mt-5">
      <span className="h1 text-center d-flex justify-content-center">
        {t('resetPassword.title')}
      </span>
      <FormProvider {...formMethods}>
        <form
          className="d-flex flex-column mt-5"
          onSubmit={formMethods.handleSubmit(onSubmit)}
        >
          <div className="w-xl-50 w-100 mx-auto ">
            <Input
              type="password"
              name="password"
              placeholder={t('resetPassword.newPassword')}
              validate={Validators([
                { validation: 'required' },
                { minParams: 8, validation: 'minLength' },
              ])}
              className="bg-light-grey text-center"
            />
            <Input
              type="password"
              name="passwordConfirmation"
              placeholder={t('resetPassword.newPasswordConfirmation')}
              validate={Validators([
                { validation: 'required' },
                { minParams: 8, validation: 'minLength' },
                {
                  validation: 'passwordConfirm',
                  passwordConfirm: formMethods.watch().password,
                },
              ])}
              className="bg-light-grey text-center"
            />
            <div className="d-flex justify-content-end ">
              <button
                disabled={isLoading}
                type="submit"
                className="btn btn-sm btn-primary mt-5"
              >
                {t('misc.submit')}
              </button>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default ResetPassword;
